<template>
    <div class="selector" v-click-outside="closeIt">
        <cta
            is-link
            class="toggle"
            :class="{ open: isOpen }"
            font-icon="fn_angleDown"
            size="S"
            type="text"
            :content="currentLabel"
            @click="toggle"
        />
        <transition name="slide">
            <ul class="options" v-if="isOpen">
                <li
                    v-for="language in languages"
                    :class="{ active: language.code === current }"
                    :key="language.code"
                    class="option"
                    @click="changeLocale(language.code)"
                >
                    <paragraph size="S" :content="language.label" />
                </li>
            </ul>
        </transition>
    </div>
</template>

<script>
import Cta from 'gvue/src/core/Cta'
import Paragraph from 'gvue/src/core/Paragraph'

export default {
    name: 'SelectorLanguage',
    components: {
        Cta,
        Paragraph
    },
    data() {
        return {
            isOpen: false,
            current: '',
            languages: [
                {
                    code: 'wo_en',
                    label: 'English'
                }
                /*
                ,
                {
                    code: 'wo_fr',
                    label: 'Français'
                }
                */
            ]
        }
    },
    computed: {
        currentLabel() {
            return this.languages.find(
                language => language.code === this.current
            ).label
        }
    },
    created() {
        this.setCurrent()
    },
    methods: {
        closeIt() {
            this.isOpen = false
        },
        toggle() {
            this.isOpen = !this.isOpen
        },
        changeLocale(locale) {
            this.updateLanding(locale)
            this.updateJson()
            this.toggle()
            this.setCurrent()
        },
        updateLanding(locale) {
            const [country, language] = locale.split('_')
            this.$landing.country = country.toUpperCase()
            this.$landing.language = language
        },
        async updateJson() {
            this.$root._json = await this.$landing.getJSON()
        },
        setCurrent() {
            const { country, language } = this.$landing
            this.current = `${country}_${language}`.toLowerCase()
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables

.selector
    position: relative
    color: $color_dark

.g
    .toggle
        margin: 0
        cursor: pointer
        color: $color_grey
        font-weight: 700
        user-select: none
        text-transform: capitalize

        &.g_link:hover ::v-deep span
            text-decoration: none

        ::v-deep
            span
                padding: 0 ($gap * 2.5) 0 $gap

            [class*="Down"]

                &::before
                    top: 50%
                    font-size: 2em
                    transform: translate(-75%, -50%) rotate(90deg) !important
                    transition: transform $easing $duration_fast

        &.open
            ::v-deep
                [class*="Down"]
                    &::before
                        transform: translate(-75%, -50%) rotate(-90deg) !important

.options
    position: absolute
    z-index: 1
    top: calc(100% + #{$gap})
    right: ($gap * -0.5)
    padding: ($gap * 0.5) 0
    background-color: $color_black
    border-radius: 4px
    box-shadow: 0 1px 2px rgba(0,0,0,0.07), 0 2px 4px rgba(0,0,0,0.07), 0 4px 8px rgba(0,0,0,0.07), 0 8px 16px rgba(0,0,0,0.07), 0 16px 32px rgba(0,0,0,0.07), 0 32px 64px rgba(0,0,0,0.07)
    list-style-type: none
    color: $color_white
    transition: transform 100ms ease-in, opacity 100ms ease-in, visibility 0s linear 100ms

.option
    padding: ($gap * 0.25) ($gap * 2.5) ($gap * 0.25) $gap
    cursor: pointer

    &.active
        [class*="g_txt"]
            font-weight: 700

    &:hover
        background-color: $color_dark

.slide-enter-active,
.slide-leave-active
  transition: opacity $easing $duration_fast, transform $easing $duration_fast

.slide-enter,
.slide-leave-to
  opacity: 0
  transform: translateY(#{$gap * 0.5})

+desktop
    .g
        .toggle
            ::v-deep
                span
                    padding-right: ($gap * 3.5)

    .option
        padding: ($gap * 0.5) ($gap * 3.5) ($gap * 0.5) ($gap * 1.5)
</style>
